import okeResponse from 'okeoke.standardresponse'
import { OrderStatus } from '../consts'

export default function vipProcessor(order, offlineEnabled, clientSocket) {
  function setVipID(vipID) {
    order.addUpdate({
      vipID
    })
  }

  function serviceFeeRound(value, rounding) {
    switch (rounding) {
      case 1:
        return Math.round(value)
      case 2:
        return Math.ceil(value)
      default:
        return Math.floor(value)
    }
  }

  function calculateDiscountAmountForPayment(reserveResult) {
    let serviceFee = order.order.serviceFee || { type: 0, percent: 0, rounding: 0 }
    let totalDiscount = +reserveResult.totalDiscount || 0
    if (serviceFee.type === 1) {
      for (let resItem of reserveResult.groupedItems || []) {
        let item = order.assembledOrderItems[resItem.uid]
        if (item) {
          if (item.sumDiscountPriceUnit > 0 && +serviceFee.percent > 0) {
            let itemCouponDiscount = 0
            for (let coupon of Object.values(resItem.coupons)) {
              itemCouponDiscount += +coupon.value
            }
            let itemDiscountAmount = (+resItem.vipDiscount + +resItem.cardDiscount + itemCouponDiscount) / +resItem.count
            let serviceFeeUnitCurrent = serviceFeeRound(item.sumDiscountPriceUnitBase * (+serviceFee.percent / 100), +serviceFee.rounding)
            let serviceFeeUnitNew = serviceFeeRound((item.sumDiscountPriceUnitBase - itemDiscountAmount) * (+serviceFee.percent / 100), +serviceFee.rounding)            
            let priceDiff = serviceFeeUnitCurrent - serviceFeeUnitNew
            if (priceDiff !== 0) {
              let diffTotal = (priceDiff * +resItem.count)
              totalDiscount += diffTotal
            }
          }
        }
      }
    }
    return totalDiscount
  }

  function reserveVip() {
    return new Promise((resolve, reject) => {
      if (order?.statuses?.getStatus(OrderStatus.ORDER_VIP_PURCHASE_FINALIZED)) {
        return resolve(okeResponse(false, 400, 'Vip already finalized', {}))
      }
      if (!clientSocket.authorized) {
        resolve(okeResponse(false, 503, 'Not connected', {}))
      } else {
        try {
          setTimeout(() => {
            resolve({ success: false, message: 'Timeout!', code: 408, data: { errMsgCode: 'request.error.timeout' } })
          }, 10000)
          clientSocket.ioclient.emit(
            'reserveVip',
            {
              orderUUID: order.order.uuid
            },
            (res) => {
              if(res.success) {
                let deductFromPayment = calculateDiscountAmountForPayment(res.data)
                res.data.deductFromPayment = deductFromPayment
              }
              resolve(res)
            }
          )
        } catch (e) {
          resolve(okeResponse(false, 500, 'Internal error', null))
        }
      }
    })
  }

  function finalizeVip() {
    return new Promise((resolve, reject) => {
      if (order?.statuses?.getStatus(OrderStatus.ORDER_VIP_PURCHASE_FINALIZED)) {
        return resolve(okeResponse(false, 400, 'Vip already finalized', {}))
      }
      if (!clientSocket.authorized) {
        resolve(okeResponse(false, 503, 'Not connected', {}))
      } else {
        try {
          setTimeout(() => {
            resolve({ success: false, message: 'Timeout!', code: 408, data: { errMsgCode: 'request.error.timeout' } })
          }, 10000)
          clientSocket.ioclient.emit(
            'finalizeVip',
            {
              orderUUID: order.order.uuid
            },
            (res) => resolve(res)
          )
        } catch (e) {
          resolve(okeResponse(false, 500, 'Internal error', null))
        }
      }
    })
  }

  return {
    setVipID,
    reserveVip,
    finalizeVip,
    calculateDiscountAmountForPayment
  }
}
